// @ts-nocheck
import { get, post, put, deleteRequest } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3500';
/**
 * @typedef {Object} OperacaoCliente
 * @property {number} Id - ID Ãºnico da operaÃ§Ã£o cliente
 * @property {number} ClienteId - ID do cliente
 * @property {number} OperacaoId - ID da operaÃ§Ã£o
 * @property {string} ClienteNome - Nome do cliente
 * @property {string} OperacaoNome - Nome da operaÃ§Ã£o
 * @property {string} Status - Status da operaÃ§Ã£o cliente
 * @property {string} DataCriacao - Data de criaÃ§Ã£o
 * @property {string} DataModificacao - Data de modificaÃ§Ã£o
 * @property {number} UsuarioCriacao - ID do usuÃ¡rio que criou
 * @property {number} UsuarioModificacao - ID do usuÃ¡rio que modificou
 * @property {string} Observacao - ObservaÃ§Ãµes
 * @property {number} DiasRecorrencia - Dias de recorrÃªncia da operaÃ§Ã£o
 * @property {boolean} RecorrenciaLigada - Se a recorrÃªncia estÃ¡ ligada
 * @property {number} ValorIndividualPallet - Valor individual por pallet
 * @property {number} ValorEtiquetas - Valor das etiquetas
 * @property {number} ValorArmazenagem - Valor da armazenagem
 * @property {number} Freetime - Freetime em dias
 * @property {string} DataVigencia - Data de vigÃªncia da operaÃ§Ã£o
 */
/**
 * @typedef {Object} OperacaoClienteCreatePayload
 * @property {number} ClienteId - ID do cliente
 * @property {number} OperacaoId - ID da operaÃ§Ã£o
 * @property {string} [Status] - Status da operaÃ§Ã£o cliente
 * @property {string} [Observacao] - ObservaÃ§Ãµes
 * @property {number} [DiasRecorrencia] - Dias de recorrÃªncia da operaÃ§Ã£o
 * @property {boolean} [RecorrenciaLigada] - Se a recorrÃªncia estÃ¡ ligada
 * @property {number} [ValorIndividualPallet] - Valor individual por pallet
 * @property {number} [ValorEtiquetas] - Valor das etiquetas
 * @property {number} [ValorArmazenagem] - Valor da armazenagem
 * @property {number} [Freetime] - Freetime em dias
 * @property {string} [DataVigencia] - Data de vigÃªncia da operaÃ§Ã£o
 */
/**
 * @typedef {Object} OperacaoClienteFilters
 * @property {number} [ClienteId] - Filtro por ID do cliente
 * @property {number} [OperacaoId] - Filtro por ID da operaÃ§Ã£o
 * @property {string} [Status] - Filtro por status
 * @property {string} [ClienteNome] - Filtro por nome do cliente
 * @property {string} [OperacaoNome] - Filtro por nome da operaÃ§Ã£o
 * @property {number} [quantidadePorPagina] - Quantidade de registros por pÃ¡gina
 * @property {number} [pagina] - NÃºmero da pÃ¡gina
 */
/**
 * @typedef {Object} OperacoesClienteResponse
 * @property {OperacaoCliente[]} registros - Lista de operaÃ§Ãµes cliente
 * @property {number} totalRegistros - Total de registros encontrados
 * @property {number} paginaAtual - PÃ¡gina atual
 * @property {number} quantidadePorPagina - Quantidade de registros por pÃ¡gina
 */
/**
 * Lista operaÃ§Ãµes cliente com filtros e paginaÃ§Ã£o
 * @param {OperacaoClienteFilters} filters - Filtros para a busca
 * @returns {Promise<OperacoesClienteResponse>} Resposta com lista de operaÃ§Ãµes cliente
 */
export const getOperacoesCliente = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    // Adicionar filtros apenas se tiverem valor
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/operacoes-cliente?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Busca uma operaÃ§Ã£o cliente especÃ­fica por ID
 * @param {number} id - ID da operaÃ§Ã£o cliente
 * @returns {Promise<OperacaoCliente>} Dados da operaÃ§Ã£o cliente
 */
export const getOperacaoClienteById = async (id) => {
    const response = await get(`${API_URL}/operacoes-cliente/${id}`);
    return response?.data || response;
};
/**
 * Cria uma nova operaÃ§Ã£o cliente
 * @param {OperacaoClienteCreatePayload} payload - Dados da operaÃ§Ã£o cliente a ser criada
 * @returns {Promise<OperacaoCliente>} OperaÃ§Ã£o cliente criada
 */
export const createOperacaoCliente = async (payload) => {
    const response = await post(`${API_URL}/operacoes-cliente`, payload);
    return response?.data || response;
};
/**
 * Atualiza uma operaÃ§Ã£o cliente existente
 * @param {number} id - ID da operaÃ§Ã£o cliente
 * @param {OperacaoClienteCreatePayload} payload - Dados atualizados da operaÃ§Ã£o cliente
 * @returns {Promise<OperacaoCliente>} OperaÃ§Ã£o cliente atualizada
 */
export const updateOperacaoCliente = async (id, payload) => {
    const response = await put(`${API_URL}/operacoes-cliente/${id}`, payload);
    return response?.data || response;
};
/**
 * Exclui uma operaÃ§Ã£o cliente
 * @param {number} id - ID da operaÃ§Ã£o cliente a ser excluÃ­da
 * @returns {Promise<void>}
 */
export const deleteOperacaoCliente = async (id) => {
    await deleteRequest(`${API_URL}/operacoes-cliente/${id}`);
};
/**
 * Busca operaÃ§Ãµes cliente por cliente
 * @param {number} clienteId - ID do cliente
 * @returns {Promise<OperacaoCliente[]>} Lista de operaÃ§Ãµes do cliente
 */
export const getOperacoesClienteByCliente = async (clienteId) => {
    const response = await get(`${API_URL}/operacoes-cliente/cliente/${clienteId}`);
    return response?.data || response || [];
};
/**
 * Busca operaÃ§Ãµes cliente por operaÃ§Ã£o
 * @param {number} operacaoId - ID da operaÃ§Ã£o
 * @returns {Promise<OperacaoCliente[]>} Lista de clientes da operaÃ§Ã£o
 */
export const getOperacoesClienteByOperacao = async (operacaoId) => {
    const response = await get(`${API_URL}/operacoes-cliente/operacao/${operacaoId}`);
    return response?.data || response || [];
};
/**
 * Busca operaÃ§Ãµes cliente por status
 * @param {string} status - Status da operaÃ§Ã£o cliente
 * @returns {Promise<OperacaoCliente[]>} Lista de operaÃ§Ãµes cliente do status
 */
export const getOperacoesClienteByStatus = async (status) => {
    const response = await get(`${API_URL}/operacoes-cliente/status/${encodeURIComponent(status)}`);
    return response?.data || response || [];
};
/**
 * ObtÃ©m estatÃ­sticas de operaÃ§Ãµes cliente
 * @returns {Promise<Object>} EstatÃ­sticas de operaÃ§Ãµes cliente
 */
export const getEstatisticasOperacoesCliente = async () => {
    const response = await get(`${API_URL}/operacoes-cliente/estatisticas`);
    return response?.data || response || {};
};
